'use es6';

import http from 'hub-http/clients/apiClient';
const BASE_ECOSYSTEM_OFFERINGS_URL = 'ecosystem/v1/offerings';
/**
 * GET ecosystem/v1/offerings/types/2
 */

export function getMarketplaceOfferings() {
  // Eco BE uses the same DB for both App and Asset listings, type-id 2 is for assets
  return http.get(`${BASE_ECOSYSTEM_OFFERINGS_URL}/types/2`);
}